export default "__VITE_ASSET__C44sTHKB__"